import {
  INVENTORY_TYPES,
  STOCK_ADJUSTMENT_300_IN,
  STOCK_ADJUSTMENT_300_OUT
} from 'src/constants';
import solveExpression from './solveExpression';
const {
  PURCHASES,
  SALES,
  PURCHASE_RETURN,
  PHANTOM_SALES,
  SALES_RETURN,
  SALES_ORDER,
  STOCK_ADJUSTMENT,
  STOCK_ADJUSTMENT_IN,
  STOCK_ADJUSTMENT_OUT,
  STOCK_ADJUSTMENT_BY_VARIANCE,
  STOCK_ADJUSTMENT_REPRICE,
  STOCK_TRANSFER_BY_BRANCH,
  STOCK_TRANSFER_BY_WH,
  PURCHASE_ORDER,
  WAVG_PURCHASES,
  WAVG_SALES,
  WAVG_STOCK_IN,
  WAVG_STOCK_OUT
} = INVENTORY_TYPES;

const getColumns = INV_TYPE =>
  ({
    [PURCHASES]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },

      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qty',
        caption: 'Qty',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'price',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'amt',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },

      {
        fld: 'muAmt',
        caption: 'Markup Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discOutrightAmt',
        caption: 'Outright Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'discOutrightSubTotal',
        caption: 'Outright Discount Sub-Total',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'discQtyRate',
        caption: 'Discount Qty Rate',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'discQtyAmt',
        caption: 'Discount Qty Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'discAmt',
        caption: 'Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'netAmt',
        caption: 'Net Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'vatCode',
        caption: 'VAT Type',
        align: 'center',
        show: false,
        mapValue: {
          0: 'Non-VAT',
          1: 'VAT',
          2: 'Exempt',
          3: 'Zero-Rated'
        },
        width: 120
      },
      {
        fld: 'vatINamt',
        caption: 'VAT',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [SALES]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qty',
        caption: 'Qty',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'price',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'amt',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'vatCode',
        caption: 'VAT Type',
        align: 'center',
        show: false,
        mapValue: {
          0: 'Non-VAT',
          1: 'VAT',
          2: 'Exempt',
          3: 'Zero-Rated'
        },
        width: 120
      },
      {
        fld: 'vatOUTamt',
        caption: 'VAT',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'muAmt',
        caption: 'Markup Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discOutrightAmt',
        caption: 'Outright Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discAmt',
        caption: 'Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'netAmt',
        caption: 'Net Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [PURCHASE_RETURN]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qty',
        caption: 'Qty',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'priceGross',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'amt',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'vatCode',
        caption: 'VAT Type',
        align: 'center',
        show: false,
        mapValue: {
          0: 'Non-VAT',
          1: 'VAT',
          2: 'Exempt',
          3: 'Zero-Rated'
        },
        width: 120
      },
      {
        fld: 'vatINamt',
        caption: 'VAT',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [PHANTOM_SALES]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qty',
        caption: 'Qty',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'price',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'amt',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'vatCode',
        caption: 'VAT Type',
        align: 'center',
        show: false,
        mapValue: {
          0: 'Non-VAT',
          1: 'VAT',
          2: 'Exempt',
          3: 'Zero-Rated'
        },
        width: 120
      },
      {
        fld: 'vatOUTamt',
        caption: 'VAT',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        formula: 'vatOUT * qty',
        renderValue: params => {
          return solveExpression({
            expression: 'vatOUT * qty',
            variables: params
          });
        },
        total: true
      },
      {
        fld: 'muAmt',
        caption: 'Markup Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discOutrightAmt',
        caption: 'Outright Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discAmt',
        caption: 'Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'netAmt',
        caption: 'Net Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [SALES_RETURN]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qty',
        caption: 'Qty',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'priceOUT',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'new_price',
        caption: 'New Price',
        align: 'right',
        isCurrency: true,
        show: false,
        width: 120
      },
      {
        fld: 'new_vatIN',
        caption: 'VAT',
        align: 'right',
        isCurrency: true,
        show: false,
        width: 120
      },
      {
        align: 'right',
        caption: 'Amount',
        fld: 'amt',
        formula: 'priceOUT * qty',
        renderValue: params => {
          return solveExpression({
            expression: 'priceOUT * qty',
            variables: params
          });
        },
        isCurrency: true,
        key: 'amt',
        total: true,
        width: 120
      },
      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [SALES_ORDER]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qty',
        caption: 'Qty',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'price',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'amt',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'vatCode',
        caption: 'VAT Type',
        align: 'center',
        show: false,
        mapValue: {
          0: 'Non-VAT',
          1: 'VAT',
          2: 'Exempt',
          3: 'Zero-Rated'
        },
        width: 120
      },
      {
        fld: 'vatOUTamt',
        caption: 'VAT',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'muAmt',
        caption: 'Markup Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discOutrightAmt',
        caption: 'Outright Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discAmt',
        caption: 'Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'netAmt',
        caption: 'Net Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [PURCHASE_ORDER]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qty',
        caption: 'Qty',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'price',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'amt',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'vatCode',
        caption: 'VAT Type',
        align: 'center',
        show: false,
        mapValue: {
          0: 'Non-VAT',
          1: 'VAT',
          2: 'Exempt',
          3: 'Zero-Rated'
        },
        width: 120
      },
      {
        fld: 'vatINamt',
        caption: 'VAT',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'muAmt',
        caption: 'Markup Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discOutrightAmt',
        caption: 'Outright Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discQtyRate',
        caption: 'Discount Qty Rate',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discAmt',
        caption: 'Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'netAmt',
        caption: 'Net Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [STOCK_TRANSFER_BY_WH]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qtyOUT',
        caption: 'Qty',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'priceOUT',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'new_price',
        caption: 'New Price',
        align: 'right',
        isCurrency: true,
        show: false,
        width: 120
      },
      {
        fld: 'new_vatIN',
        caption: 'VAT',
        align: 'right',
        isCurrency: true,
        show: false,
        width: 120
      },
      {
        fld: 'amt',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'vatCode',
        caption: 'VAT Type',
        align: 'center',
        show: false,
        mapValue: {
          0: 'Non-VAT',
          1: 'VAT',
          2: 'Exempt',
          3: 'Zero-Rated'
        },
        width: 120
      },
      {
        fld: 'vatOUTamt',
        caption: 'VAT',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [STOCK_ADJUSTMENT_IN]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qty',
        caption: 'Qty',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'price',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'amt',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'muAmt',
        caption: 'Markup Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discOutrightAmt',
        caption: 'Outright Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discAmt',
        caption: 'Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'netAmt',
        caption: 'Net Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [STOCK_ADJUSTMENT_OUT]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qty',
        caption: 'Qty',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'price',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'amt',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'muAmt',
        caption: 'Markup Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discOutrightAmt',
        caption: 'Outright Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discAmt',
        caption: 'Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'netAmt',
        caption: 'Net Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [STOCK_ADJUSTMENT_REPRICE]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qtyIN',
        caption: 'IN',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'priceIN',
        caption: 'Price IN',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'qtyOUT',
        caption: 'OUT',
        width: 80,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'priceOUT',
        caption: 'Price OUT',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'new_price',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        show: false,
        width: 120
      },
      {
        fld: 'new_vatIN',
        caption: 'VAT',
        align: 'right',
        isCurrency: true,
        show: false,
        width: 120
      },
      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [STOCK_ADJUSTMENT_BY_VARIANCE]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'qtyREC',
        caption: 'Record',
        width: 120,
        isCurrency: true,
        align: 'right'
      },
      {
        fld: 'qtyREC_CS',
        caption: 'CS',
        width: 120,
        isCurrency: true,
        align: 'right',
        show: false
      },
      {
        fld: 'qtyREC_SC',
        caption: 'SC',
        width: 120,
        isCurrency: true,
        align: 'right',
        show: false
      },
      {
        fld: 'qtyREC_PC',
        caption: 'PC',
        width: 120,
        isCurrency: true,
        align: 'right',
        show: false
      },
      {
        fld: 'qtyACT',
        caption: 'Actual',
        width: 120,
        isCurrency: true,
        align: 'right'
      },
      {
        fld: 'qtyACT_CS',
        caption: 'CS',
        width: 120,
        isCurrency: true,
        align: 'right',
        show: false
      },
      {
        fld: 'qtyACT_SC',
        caption: 'SC',
        width: 120,
        isCurrency: true,
        align: 'right',
        show: false
      },
      {
        fld: 'qtyACT_PC',
        caption: 'PC',
        width: 120,
        isCurrency: true,
        align: 'right',
        show: false
      },
      {
        fld: 'qtyIN',
        caption: 'IN',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'qtyIN_CS',
        caption: 'CS',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true,
        show: false
      },
      {
        fld: 'qtyIN_SC',
        caption: 'SC',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true,
        show: false
      },
      {
        fld: 'qtyIN_PC',
        caption: 'PC',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true,
        show: false
      },
      {
        fld: 'qtyOUT',
        caption: 'OUT',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'qtyOUT_CS',
        caption: 'CS',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true,
        show: false
      },
      {
        fld: 'qtyOUT_SC',
        caption: 'SC',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true,
        show: false
      },
      {
        fld: 'qtyOUT_PC',
        caption: 'PC',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true,
        show: false
      },
      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [STOCK_ADJUSTMENT]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'qtyIN',
        caption: 'IN',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'priceIN',
        caption: 'Price IN',
        width: 120,
        isCurrency: true,
        align: 'right'
      },
      {
        fld: 'totalAmtIN',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        formula: 'totalAmtIN',
        total: true
      },
      {
        fld: 'qtyOUT',
        caption: 'OUT',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'priceOUT',
        caption: 'Price OUT',
        width: 120,
        isCurrency: true,
        align: 'right'
      },
      {
        fld: 'totalAmtOUT',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        formula: 'totalAmtOUT',
        total: true
      },
      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [STOCK_ADJUSTMENT_300_IN]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qtyIN',
        caption: 'Qty',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'priceIN',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'totalAmtIN',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [STOCK_ADJUSTMENT_300_OUT]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qtyOUT',
        caption: 'Qty',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'priceOUT',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'totalAmtOUT',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [STOCK_TRANSFER_BY_BRANCH]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qtyOUT',
        caption: 'Qty',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'priceOUT',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'new_price',
        caption: 'New Price',
        align: 'right',
        isCurrency: true,
        show: false,
        width: 120
      },
      {
        fld: 'new_vatIN',
        caption: 'VAT',
        align: 'right',
        isCurrency: true,
        show: false,
        width: 120
      },
      {
        fld: 'amt',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },

      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [WAVG_PURCHASES]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qtyIN',
        caption: 'Qty',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'priceIN',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'amt',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'vatCode',
        caption: 'VAT Type',
        align: 'center',
        show: false,
        mapValue: {
          0: 'Non-VAT',
          1: 'VAT',
          2: 'Exempt',
          3: 'Zero-Rated'
        },
        width: 120
      },
      {
        fld: 'vatINamt',
        caption: 'VAT',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'muAmt',
        caption: 'Markup Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discOutrightAmt',
        caption: 'Outright Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discAmt',
        caption: 'Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'netAmt',
        caption: 'Net Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [WAVG_SALES]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qtyOUT',
        caption: 'Qty',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'priceOUT',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'amt',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'vatCode',
        caption: 'VAT Type',
        align: 'center',
        show: false,
        mapValue: {
          0: 'Non-VAT',
          1: 'VAT',
          2: 'Exempt',
          3: 'Zero-Rated'
        },
        width: 120
      },
      {
        fld: 'vatOUTamt',
        caption: 'VAT',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'muAmt',
        caption: 'Markup Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discOutrightAmt',
        caption: 'Outright Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discAmt',
        caption: 'Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'netAmt',
        caption: 'Net Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [WAVG_STOCK_IN]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qtyIN',
        caption: 'Qty',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'priceIN',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'amt',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'muAmt',
        caption: 'Markup Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discOutrightAmt',
        caption: 'Outright Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discAmt',
        caption: 'Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'netAmt',
        caption: 'Net Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    [WAVG_STOCK_OUT]: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'unit',
        caption: 'Unit',
        width: 100
      },
      {
        fld: 'BN',
        caption: 'BN',
        width: 150,
        show: false
      },
      {
        fld: 'ProdDate',
        caption: 'Prod. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'ExpDate',
        caption: 'Exp. Date',
        width: 150,
        show: false,
        isDate: true,
        format: 'MM/DD/YYYY'
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      {
        fld: 'qtyOUT',
        caption: 'Qty',
        isCurrency: true,
        width: 80,
        align: 'right',
        total: true
      },
      {
        fld: 'priceOUT',
        caption: 'Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'amt',
        caption: 'Amount',
        width: 120,
        isCurrency: true,
        align: 'right',
        total: true
      },
      {
        fld: 'muAmt',
        caption: 'Markup Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discOutrightAmt',
        caption: 'Outright Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'discAmt',
        caption: 'Discount Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },

      {
        fld: 'netAmt',
        caption: 'Net Amount',
        width: 120,
        align: 'right',
        show: false,
        isCurrency: true,
        total: true
      },
      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ],
    ['SN_PRICE_LOG']: [
      {
        fld: 'ProdCd',
        caption: 'Product Code',
        width: 180,
        show: true
      },
      {
        fld: 'sProd',
        caption: 'Description',
        width: 300
      },
      {
        fld: 'SN',
        caption: 'SN',
        width: 150,
        show: false
      },
      {
        fld: 'SN2',
        caption: 'SN2',
        width: 150,
        show: false
      },
      // {
      //   fld: 'priceIN',
      //   caption: 'Inventory Price',
      //   align: 'right',
      //   isCurrency: true,
      //   show: false,
      //   width: 120
      // },
      {
        fld: 'current_price',
        caption: 'Current Price',
        align: 'right',
        isCurrency: true,
        show: false,
        width: 120
      },
      {
        fld: 'rebate',
        caption: 'Rebate',
        align: 'right',
        isCurrency: true,
        width: 120
      },
      {
        fld: 'new_price',
        caption: 'New Price',
        align: 'right',
        isCurrency: true,
        width: 120
      },

      {
        fld: 'remarks',
        caption: 'Remarks',
        width: 300
      }
    ]
  }[INV_TYPE]);

export default getColumns;
